var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-app",
        { staticClass: "background", attrs: { dark: "" } },
        [
          _c("ToolBar", {
            attrs: { title: _vm.title },
            on: {
              "menu-open": function($event) {
                _vm.show_drawer = true
              }
            }
          }),
          _vm._v(" "),
          _c("FileOpenerFallback"),
          _vm._v(" "),
          _c("AppVersionChecker"),
          _vm._v(" "),
          _c(
            "v-content",
            { attrs: { id: "gravity-content" } },
            [_c("AppStatusMessage"), _vm._v(" "), _c("router-view")],
            1
          ),
          _vm._v(" "),
          _c("Launcher", {
            attrs: {
              dialog: _vm.launcher.dialog && _vm.launcher.version === 1,
              jd_id: _vm.launcher.jd_id,
              parameters: _vm.launcher.parameters,
              param: _vm.launcher.param,
              parent_jr_id: _vm.launcher.parent_jr_id
            },
            on: {
              close: function($event) {
                return _vm.closeLauncher()
              }
            }
          }),
          _vm._v(" "),
          _c("LauncherV2", {
            attrs: {
              dialog: _vm.launcher.dialog && _vm.launcher.version === 2,
              jd_id: _vm.launcher.jd_id,
              parameters: _vm.launcher.parameters,
              param: _vm.launcher.param,
              parent_jr_id: _vm.launcher.parent_jr_id,
              direct_edit: _vm.launcher.direct_edit
            },
            on: {
              close: function($event) {
                return _vm.closeLauncher()
              },
              "remove-dupli-data": function($event) {
                _vm.launcher.parent_jr_id = null
                _vm.launcher.parameters = {}
              }
            }
          }),
          _vm._v(" "),
          _c("EventDial"),
          _vm._v(" "),
          _c("Toaster"),
          _vm._v(" "),
          _c("ModalAsset"),
          _vm._v(" "),
          _c("SwitchPlayer", {
            attrs: { filepath: _vm.switch_player_filepath },
            on: {
              close: function($event) {
                _vm.switch_player_filepath = null
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/App.vue
// module id = null
// module chunks = 